export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  mode: 'payment' | 'subscription';
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'prod_RonV9UG61Vtyk7',
    priceId: 'price_1RfRUSP7CWjQ0SEIKKJELyB8',
    name: 'DocHelper Basic',
    description: 'Perfect for individuals getting started with AI-powered document creation.',
    price: 9.99,
    mode: 'subscription'
  },
  {
    id: 'prod_RonJO81Y540F5I',
    priceId: 'price_1RfRVgP7CWjQ0SEIoh8ApXB0',
    name: 'DocHelper AI',
    description: 'Advanced AI-powered document processing with premium features.',
    price: 19.99,
    mode: 'subscription'
  },
  {
    id: 'prod_RwdURnX23BpiH5',
    priceId: 'price_1R2kDeP7CWjQ0SEI5kmQjXZu',
    name: 'DocHelper Team',
    description: 'Enterprise-grade features with API access and white-label options.',
    price: 29.99,
    mode: 'subscription'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};

export const getProductById = (id: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.id === id);
};